<template lang="pug">
#timeline
    .item-historico(
        v-if='historicoAgrupadoPorSafra && historicoAgrupadoPorSafra.length',
        v-for='(hist, index) in historicoAgrupadoPorSafra',
        :key='index',
        :class='{ active: isSelected(index) }',
        @click='selectedValue = index'
    )
        .marker
        h5.titulo {{ getTitulo(hist) }}

        .info(v-if='isSelected(index)')
            h6.detail Produtividade: {{ getProdutividades(hist) }}
            h6.detail Área Plantada: {{ getAreasPlantadas(hist) }}

    empty-result(
        v-if='!historico || !historico.length',
        :min-height='150',
        icon-class='mdi-alert-octagon',
        message='Não há dados históricos processados para essa área'
    )
</template>

<script>
import { CULTURAS } from '@/utils/TipoCultura';
import EmptyResult from '@/components/EmptyResult';

import formatters from '@/utils/formatters';

export default {
    name: 'Timeline',

    components: { EmptyResult },

    props: {
        historico: {
            type: Array,
            required: true
        },
        selected: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            selectedValue: null,
            historicoAgrupadoPorSafra: null
        };
    },

    methods: {
        isSelected(indice) {
            return indice === this.selectedValue;
        },
        cultura(codigoCultura) {
            return CULTURAS[codigoCultura].nome;
        },
        isAlgodao(codigoCultura) {
            return codigoCultura === CULTURAS.ALGODAO.codigo;
        },
        getTitulo(historico) {
            if (historico.historicosAgro.length === 1) {
                return `${historico.safra.descricao} - ${historico.historicosAgro[0].cultura.nome}`;
            } else {
                return `${
                    historico.safra.descricao
                } - ${historico.historicosAgro
                    .map(h => h.cultura.nome)
                    .join(' e ')}`;
            }
        },
        getProdutividades(historico) {
            return `${historico.historicosAgro
                .map(h => this.getProdutividade(h))
                .join(' e ')}`;
        },
        getProdutividade(historico) {
            return historico.produtividadeEstimadaSacasHa
                ? `${historico.cultura.nome}: ${formatters.formatNumber(
                      historico.produtividadeEstimadaSacasHa
                  )} sc/ha`
                : 'Sem dados';
        },
        getAreasPlantadas(historicos) {
            return `${historicos.historicosAgro
                .map(h => this.getAreaPlantada(h))
                .join(' e ')}`;
        },
        getAreaPlantada(historico) {
            return historico.areaColhidaHa
                ? `${historico.cultura.nome}: ${formatters.formatNumber(
                      historico.areaColhidaHa
                  )} ha`
                : 'Sem dados';
        },
        onChange(selectedValue) {
            const idSafra = this.historico.slice(0, 5)[selectedValue].safra.id;
            this.historicoAgrupadoPorSafra = this.historico.slice(0, 5);
            this.$emit('on-change', idSafra);
        }
    },

    watch: {
        selectedValue(selectedValue) {
            this.onChange(selectedValue);
        },
        historico(historico) {
            this.historicoAgrupadoPorSafra = historico.slice(0, 5);

            this.onChange(0);
        }
    },

    created() {
        this.selectedValue = this.selected;
    }
};
</script>

<style lang="scss" scoped>
#timeline {
    width: 100%;

    .item-historico {
        height: 60px;
        border: 1px solid var(--default-border-color);
        padding: 22px 20px;
        cursor: pointer;
        position: relative;
        background-color: var(--selected-background-color);

        .marker {
            display: none;
            position: absolute;
            @include box(20px);
            background-color: var(--white);
            top: 40px;
            right: -10px;
            transform: rotate(45deg);
            z-index: 1099;
        }

        .titulo {
            color: var(--secondary);
        }

        .info {
            .detail {
                color: var(--primary-font-color);
            }
        }
    }

    .item-historico.active {
        height: 100px;
        background-color: var(--white);

        .marker {
            display: block;
        }

        .titulo {
            color: var(--primary);
            margin-bottom: 10px;
        }

        .info {
            .detail:first-child {
                margin-bottom: 5px;
            }
        }
    }
}
</style>
